Vue.component('ack-alpha-ai-title', {
   delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
   template: '#ack-alpha-ai-title',
   mounted() {


   },
   props:{
      alphaAiInfo: { // :product-info
         type: Object,
         required: true
      },
      isMobile: {
        type: Boolean,
        required: true
      },
      shopProductInfo: {
        type: Object,
        required: false
      },
   },
   computed: {
     //...Vuex.mapGetters('shop', ['productList']),

   },
   data() {
     return {

     }
   },
   methods: {
     //...Vuex.mapActions(['sayHi', 'someAction']),
     ...Vuex.mapActions('shop', ['buyNow']),

     onTryPremiumClick(){
      const newWindow = window.open('', '_blank')
      this.buyNow({variantId: 'gid://shopify/ProductVariant/39881259712615', discountCodeArray: ['ALPHA30DAYS']})
      .then((url)=> {
        openCheckoutUrl(url, newWindow)
      })
      .catch(() => {
        newWindow.close()
      })
    }

   },
   beforeDestroy() {

   },
   watch: {
    isMobile: {
      handler() {


      },
      deep: false
    }
  }
 })